import { SelectTheme } from '@kite-js/theme-types';

const select: SelectTheme = {
    px: 'S',
    py: 'L',
    border: 'S',
    borderRadius: 'S',
};

export default select;
